export const content = {
    domain: "Securityfinance",
    footer: "securietyfinace.com",
    title1: "Loans from $100 - $5,000!",
  };
  